import React from 'react';
import PropTypes from 'prop-types';
import htmlReactParser from 'html-react-parser';

const Base = ({
	onCloseClick,
	title,
	description,
	ctaPrimaryLabel,
	ctaPrimaryLink,
	ctaSecondaryLabel,
	ctaSecondaryLink,
}) => {
	const hasLabel = ctaPrimaryLabel || ctaSecondaryLabel;

	return (
		<section className="modal__base">
			<button type="button" className="modal__close modal__base__close" onClick={onCloseClick} />
			<h1 className="modal__base__title">{title}</h1>
			<div className={`modal__base__description${hasLabel ? ' modal__base__description--has-margin' : ''}`}>{ htmlReactParser(description) }</div>
			{hasLabel
				? (
					<div className="modal__base__btn-container">
						{ctaPrimaryLabel
							? (
								<a href={ctaPrimaryLink} className="btn btn--primary">{ctaPrimaryLabel}</a>
							)
							: ''
						}
						{ctaSecondaryLabel
							? (
								<a href={ctaSecondaryLink} className="btn btn--secondary">
									{ctaSecondaryLabel}
									<span className="btn__arrow-angle" />
								</a>
							)
							: ''
						}
					</div>
				)
				: ''
			}
		</section>
	);
};

Base.defaultProps = {
	onCloseClick: () => { },
	title: '',
	description: '',
	ctaPrimaryLabel: '',
	ctaPrimaryLink: '',
	ctaSecondaryLabel: '',
	ctaSecondaryLink: '',
};

Base.propTypes = {
	onCloseClick: PropTypes.func,
	title: PropTypes.string,
	description: PropTypes.string,
	ctaPrimaryLabel: PropTypes.string,
	ctaPrimaryLink: PropTypes.string,
	ctaSecondaryLabel: PropTypes.string,
	ctaSecondaryLink: PropTypes.string,
};

export default Base;
